import React, { useState, useEffect } from "react";
import { api_path } from "../shared";// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionType,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig.js";

// Sample app imports
import { BookingConfirmationForm } from "../components/SalesOrder/BookingConfirmationForm";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";

export function BookingConfirmation() {
  const authRequest = {
    ...loginRequest,
  };
  const [getUserID, setUserID] = useState();
  const [getUserRole, setUserRole] = useState();
  const [getEmpCode, setEmpCode] = useState();
  const [getCRM_UID, setCRM_UID] = useState();
  const [getUserEMail, setUserEmail] = useState("");
  const { accounts } = useMsal();

  const BookingConfirmationContent = () => {
    return <BookingConfirmationForm 
    USER_EMAIL={accounts[0]?.username}
    EMP_CODE={getEmpCode}
    USER_ROLE={getUserRole}
    CRM_ID={getCRM_UID}
    />;
  };
  useEffect(() => {
    setUserEmail(accounts[0]?.username);
    fetchUserRole(accounts[0]?.username);
  });
  function fetchUserRole(userEmail) {
    fetch(api_path + "/USER_ROLE.php?USER_EMAIL=" + userEmail)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          if(i.USER_ROLE_ID==0){
            window.location = "/s-crm/Home?status=denined";
          }else{
            setUserRole(i.USER_ROLE_ID);
            setCRM_UID(i.CRM_UID);
            setEmpCode(i.EMP_CODE);
          }
        }
      });
  }
  useEffect(() => {
    var data = {
      ROLE_ID: getUserRole,
      USER_EMAIL: getUserEMail,
      MENU_URL:window.location.pathname,
    };
    fetch(api_path + "/GET_AUTHEN_URL.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
          if (result["status"] == "200") {
            if (result["success"] == "0") {
              window.location = "/s-crm/Home?status=denined";
            }
          }
      });
  }, []);
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <getAccount />
      <BookingConfirmationContent />
    </MsalAuthenticationTemplate>
  );
}
